__turbopack_context__.v({
  "className": "inter_c9198a6b-module__hhyepa__className",
});
